/**
 * © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED
 * Tinder Obsidian v10.19.0
 * Do not edit directly
 * Generated on Fri, 08 Nov 2024 21:12:45 GMT
 */

import { ThemeSizing } from '../types';

export const SIZING_0: ThemeSizing = 1;
export const SIZING_5: ThemeSizing = 2;
export const SIZING_10: ThemeSizing = 4;
export const SIZING_15: ThemeSizing = 6;
export const SIZING_20: ThemeSizing = 8;
export const SIZING_30: ThemeSizing = 12;
export const SIZING_40: ThemeSizing = 16;
export const SIZING_50: ThemeSizing = 20;
export const SIZING_60: ThemeSizing = 24;
export const SIZING_70: ThemeSizing = 28;
export const SIZING_80: ThemeSizing = 32;
export const SIZING_90: ThemeSizing = 36;
export const SIZING_100: ThemeSizing = 40;
export const SIZING_110: ThemeSizing = 44;
export const SIZING_120: ThemeSizing = 48;
export const SIZING_125: ThemeSizing = 50;
export const SIZING_130: ThemeSizing = 52;
export const SIZING_140: ThemeSizing = 56;
export const SIZING_150: ThemeSizing = 60;
export const SIZING_160: ThemeSizing = 64;
export const SIZING_170: ThemeSizing = 68;
export const SIZING_180: ThemeSizing = 72;
export const SIZING_190: ThemeSizing = 76;
export const SIZING_200: ThemeSizing = 80;
export const SIZING_210: ThemeSizing = 84;
export const SIZING_220: ThemeSizing = 88;
export const SIZING_230: ThemeSizing = 92;
export const SIZING_240: ThemeSizing = 96;
export const SIZING_BUTTON_BORDER_RADIUS = SIZING_130;
export const SIZING_BORDER_WIDTH_THIN = SIZING_0;
export const SIZING_BORDER_WIDTH_REGULAR = SIZING_5;
export const SIZING_DIMENSION_XXXSMALL = SIZING_60;
export const SIZING_DIMENSION_XXSMALL = SIZING_70;
export const SIZING_DIMENSION_XSMALL = SIZING_80;
export const SIZING_DIMENSION_SMALL = SIZING_90;
export const SIZING_DIMENSION_MEDIUM = SIZING_100;
export const SIZING_DIMENSION_LARGE = SIZING_110;
export const SIZING_DIMENSION_XLARGE = SIZING_120;
export const SIZING_DIMENSION_XXLARGE = SIZING_130;
export const SIZING_ICON_XSMALL = SIZING_30;
export const SIZING_ICON_SMALL = SIZING_40;
export const SIZING_ICON_MEDIUM = SIZING_50;
export const SIZING_ICON_LARGE = SIZING_60;
export const SIZING_ICON_XLARGE = SIZING_70;
export const SIZING_BORDER_RADIUS_XXSMALL = SIZING_5;
export const SIZING_BORDER_RADIUS_XSMALL = SIZING_10;
export const SIZING_BORDER_RADIUS_SMALL = SIZING_20;
export const SIZING_BORDER_RADIUS_MEDIUM = SIZING_30;
export const SIZING_BORDER_RADIUS_LARGE = SIZING_40;
export const SIZING_BORDER_RADIUS_XLARGE = SIZING_50;
export const SIZING_BORDER_RADIUS_XXLARGE = SIZING_60;
export const SIZING_BORDER_RADIUS_XXXLARGE = SIZING_70;
export const SIZING_PADDING_XXSMALL = SIZING_5;
export const SIZING_PADDING_XSMALL = SIZING_10;
export const SIZING_PADDING_SMALL = SIZING_20;
export const SIZING_PADDING_MEDIUM = SIZING_30;
export const SIZING_PADDING_LARGE = SIZING_40;
export const SIZING_PADDING_XLARGE = SIZING_50;
export const SIZING_PADDING_XXLARGE = SIZING_60;
export const SIZING_BUTTON_LARGE_ICON = SIZING_ICON_SMALL;
export const SIZING_BUTTON_MEDIUM_ICON = SIZING_ICON_SMALL;
export const SIZING_BUTTON_SMALL_ICON = SIZING_ICON_XSMALL;
export const SIZING_BUTTON_BORDER_WIDTH = SIZING_BORDER_WIDTH_REGULAR;
export const SIZING_BUTTON_LARGE_PADDING_HORIZONTAL = SIZING_PADDING_XXLARGE;
export const SIZING_BUTTON_LARGE_PADDING_VERTICAL = SIZING_PADDING_MEDIUM;
export const SIZING_BUTTON_MEDIUM_PADDING_HORIZONTAL = SIZING_PADDING_XLARGE;
export const SIZING_BUTTON_MEDIUM_PADDING_VERTICAL = SIZING_PADDING_SMALL;
export const SIZING_BUTTON_SMALL_PADDING_HORIZONTAL = SIZING_PADDING_LARGE;
export const SIZING_BUTTON_SMALL_PADDING_VERTICAL = SIZING_PADDING_SMALL;
